/* Om oss: linja trekkes fra venstre mens man scroller, og årstallene tennes
 * etter hvert som den passerer dem.
 *
 * Bare på brede skjermer. Under 1025 px står punktene i flere rader, og da
 * gir en vannrett linje ingen mening. */

import gsap from 'gsap';
import { $, $$, mindreBevegelse } from '../kjerne/verktoy.js';

export function startTidslinje() {
  const tidslinje = $('#tidslinje');
  if (!tidslinje || mindreBevegelse.matches) return;

  const punkter = $$('.tidspunkt', tidslinje);

  gsap.from(punkter, {
    y: 40, opacity: 0, stagger: .1, duration: 1, ease: 'expo.out',
    scrollTrigger: { trigger: tidslinje, start: 'top 82%' },
  });

  gsap.matchMedia().add('(min-width: 1025px)', () => {
    const strek = $('.tidslinje-linje i', tidslinje);

    gsap.fromTo(strek, { scaleX: 0 }, {
      scaleX: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: tidslinje,
        start: 'top 80%',
        end: 'bottom 55%',
        scrub: true,
        onUpdate: selv => {
          punkter.forEach((el, i) => {
            const tent = selv.progress >= i / punkter.length;
            el.style.setProperty('--merke-skala', tent ? '1' : '0');
          });
        },
      },
    });

    // Punktene starter slukket når linja skal trekkes.
    for (const el of punkter) el.style.setProperty('--merke-skala', '0');

    return () => {
      for (const el of punkter) el.style.removeProperty('--merke-skala');
      gsap.set(strek, { scaleX: 1 });
    };
  });
}
